import script from "./TripStop.vue?vue&type=script&setup=true&lang=js"
export * from "./TripStop.vue?vue&type=script&setup=true&lang=js"

import "./TripStop.vue?vue&type=style&index=0&id=634c4579&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-634c4579"]])

export default __exports__